import { render, staticRenderFns } from "./TrashBinList.vue?vue&type=template&id=8ad71122&scoped=true"
import script from "./TrashBinList.vue?vue&type=script&lang=js"
export * from "./TrashBinList.vue?vue&type=script&lang=js"
import style0 from "./TrashBinList.vue?vue&type=style&index=0&id=8ad71122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad71122",
  null
  
)

export default component.exports